<mat-form-field
  appearance="outline"
  [formGroup]="formGroup"
  style="margin-bottom: -1.25em; width: 100%; position: relative;"
  >
  <mat-label>{{config.label}}</mat-label>

  <mat-chip-listbox #chipList>
    @if (selecionado) {
      <mat-chip-option>
        {{fileName}}
        @if (!controle.disabled) {
          <button
            mat-icon-button
            type="button"
            matSuffix
            (click)="limpar()"
            >
            <mat-icon>clear</mat-icon>
          </button>
        }
      </mat-chip-option>
    }
    <input
      matInput
      readonly
      class="cursor-pointer"
      (click)="fileInput.click()"
      />
    </mat-chip-listbox>

    @if (fileName) {
      <mat-icon
        matSuffix
        class="cursor-pointer"
        (mouseenter)="atualizaSrcImg(); imageWrapper.style.display = 'block'"
        (mouseleave)="imageWrapper.style.display='none'"
        (click)="maximizaImagem()">
        {{config.sufixo}}
      </mat-icon>
    }

    <input
      type="file"
      #fileInput
      id="uploadFile"
      (change)="onFileChanged($event)"
      [accept]="config.tiposAceitos"
      [hidden]="true"
      />
    </mat-form-field>
    <div #imageWrapper class="img-container">
      <img #image />
    </div>
